import React from 'react';
import { connect } from 'react-redux';

import { sendRequest } from '../../helpers/global.js';

import '../../sass/components/common/FeedbackListView.scss';

const mapStoreToProps = (store) => {
  return {
    venues: store.data.venues || [],
  }
};

class FeedbackListView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loaded: false,
    };
  }

  componentDidMount = () => {
    this.requestData();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.filter !== this.props.filter) {
      this.setState({loaded: false});
      this.requestData();
    }
  }

  requestData = (merge = false) => {
    const filter = this.props.filter || {};
    if (!filter.from || !filter.to) {
      return;
    }
    const lastItem = this.state.data && this.state.data[this.state.data.length - 1];
    sendRequest({
      method: 'dashboard/feedbacks_list',
      type: 'GET',
      data: {
        ...this.props.filter,
        venue_ids: this.props.venues,
        after_id: lastItem ? lastItem.id : null,
      },
      success: (data) => {
        if (!data || !data.length) {
          this.setState({loaded: true});
        } else if (merge) {
          this.setState({data: [...this.state.data, ...data]});
        } else {
          this.setState({data});
        }
      },
      error: (data) => {
      }
    });
  }

  renderItem = (item, index) => {
    const feedback = [
      'misc_feedback', 'food_explanation', 'service_explanation', 'ambience_explanation'
    ].map(key => item[key])
    .filter(val => !!val)
    .join(' ');
    return (
      <tr key={index}>
        <td>{item.date}</td>
        <td>{item.experience}</td>
        <td>{feedback}</td>
      </tr>
    )
  }

  render = () => {
    const data = this.state.data || []
    return (
      <div className='feedbackListView'>
        <div className='tableContainer'>
          <table>
            <thead>
              <tr>
                <th width='88px'>Date</th>
                <th width='88px'>Experience</th>
                <th>Feedback</th>
              </tr>
            </thead>
            <tbody>
              {data.map(this.renderItem)}
            </tbody>
          </table>
        </div>
        {this.state.loaded && !data.length ?
          <div className='emptyPlaceholder'>No feedback yet</div>
        : null}
        {this.state.loaded ? null :
          <div
            className='loadMore'
            onClick={() => this.requestData(true)}
          >
            View more
            <svg width='15' height='9' viewBox='0 0 15 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M0.938969 0.760992C0.587969 1.11199 0.587969 1.67899 0.938969 2.02999L6.86997 7.96099C7.22097 8.31199 7.78797 8.31199 8.13897 7.96099L14.061 2.03899C14.412 1.68799 14.412 1.12099 14.061 0.769992C13.71 0.409992 13.143 0.409992 12.792 0.760992L7.49997 6.05299L2.20797 0.760992C1.85697 0.409992 1.28997 0.409992 0.938969 0.760992Z'/>
            </svg>
          </div>
        }
      </div>
    )
  }

}

export default connect(mapStoreToProps)(FeedbackListView);
